// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","HasSeen":"cn_a bhl_fk bhl_vt bhl_xe bhl_h"};